import {Component, Input} from "@angular/core";
import {RuleConfig} from "../../../../../model/channels.model";

@Component({
  selector: "admin-channels-rule-details",
  templateUrl: "./rule-details.component.html",
  styleUrls: ["./rule-details.component.css"]
})
export class RuleDetailsComponent {

  @Input() title?: String;
  @Input() rule?: RuleConfig;

  get titleLabel() {
    return this.title ? this.title : "";
  }
}
